import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Star, Users } from 'lucide-react';
import { mockData, iconMap } from '../mock';

const ServiceCard = ({ service, categorySlug }) => {
  const navigate = useNavigate();
  const IconComponent = iconMap[service.icon] || Star;
  const targetPath = categorySlug === 'mutual-funds' ? '/mutual-funds' : `/services/${categorySlug}`;

  return (
    <div
      className="catalog-card"
      data-testid={`service-card-${service.slug}`}
      onClick={() => navigate(targetPath)}
    >
      <div className="catalog-card-icon">
        <IconComponent size={28} />
      </div>
      <p className="catalog-card-name">{service.name}</p>
      <div className="catalog-card-meta">
        <span className="catalog-card-rating">
          {service.rating} <Star size={12} fill="#00A86B" stroke="#00A86B" />
        </span>
        <span className="catalog-card-users">
          {service.users} <Users size={12} />
        </span>
      </div>
    </div>
  );
};

const ServiceCatalog = () => {
  const navigate = useNavigate();

  const getCategoryPath = (slug) => {
    return slug === 'mutual-funds' ? '/mutual-funds' : `/services/${slug}`;
  };

  return (
    <section className="catalog-section" data-testid="service-catalog">
      <div className="catalog-container">
        <h2 className="catalog-title">One Platform for all your Investment Needs</h2>
        {mockData.serviceCategories.map((category, idx) => (
          <div key={idx} className="catalog-category" data-testid={`category-${category.slug}`}>
            <h3
              className="catalog-category-title catalog-category-link"
              onClick={() => navigate(getCategoryPath(category.slug))}
              data-testid={`category-link-${category.slug}`}
            >
              {category.title}
            </h3>
            <div className="catalog-cards-grid">
              {category.services.map((service, sIdx) => (
                <ServiceCard
                  key={sIdx}
                  service={service}
                  categorySlug={category.slug}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceCatalog;
